import React from 'react';

import { T } from 'react-translator-component';

import { OcppTag } from '../../../types/responses/OcppTags';
import { InTransactionIcon } from '../../molecules/InTransactionIcon/InTransactionIcon';

const MPT = ['Sem nome', T('Undefined'), T('Does not own')];

const innerDataFormater = (ocppTag: OcppTag) => {
  return {
    ocppTagPk: ocppTag.ocppTagPk,
    idTag: ocppTag.idTag,
    parentIdTag: ocppTag.parentIdTag,
    parentUserName: ocppTag.parentUserName,
    ownerUserPk: ocppTag.ownerUserPk,
    ownerUserName: ocppTag.ownerUserName,
    isFreeRecharge: ocppTag.isFreeRecharge,
  };
};

const listFormater = (list: OcppTag[]) => {
  let cardsList: any = [];
  let innerData: any = [];
  list !== undefined &&
    list.forEach((ocppTag) => {
      cardsList = [
        ...cardsList,
        [
          { value: ocppTag.idTag || T(MPT[2]), subValue: '', icon: <></>, size: '25%' },
          { value: T(ocppTag.type) || T(MPT[2]), subValue: '', icon: <></>, size: '15%' },
          { value: ocppTag.parentUserName || ocppTag.parentIdTag || T(MPT[2]), subValue: '', icon: <></>, size: '25%' },
          { value: ocppTag.tenant, subValue: '', icon: <></>, size: '25%' },
          {
            value: <InTransactionIcon inTransaction={ocppTag?.inTransaction} />,
            subValue: '',
            icon: <></>,
            size: '10%',
          },
        ],
      ];

      innerData = [...innerData, innerDataFormater(ocppTag)];
    });

  return { cardsList, innerData };
};

export const combiningObjects = (list: OcppTag[], header) => {
  return {
    header,
    ...listFormater(list),
  };
};
